@if (icon() === "mobile") {
  <svg
    class="icon icon--mobile"
    viewBox="0 0 30 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 33H15.02M5 1H25C27.2091 1 29 2.79086 29 5V37C29 39.2091 27.2091 41 25 41H5C2.79086 41 1 39.2091 1 37V5C1 2.79086 2.79086 1 5 1Z"
      stroke="var(--color-accent)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
} @else {
  <svg
    class="icon icon--desktop"
    viewBox="0 0 46 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 40H31.3333M22.6667 31.3333V40M5.33333 1H40C42.3932 1 44.3333 2.9401 44.3333 5.33333V27C44.3333 29.3932 42.3932 31.3333 40 31.3333H5.33333C2.9401 31.3333 1 29.3932 1 27V5.33333C1 2.9401 2.9401 1 5.33333 1Z"
      stroke="#DAE62C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
}
